import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import AboutContent from '../components/about/AboutContent';
import BasketSection from '../components/about/BasketSection';
import aboutHero from '../assets/images/hero/about.png';
import Stats from '../components/about/Stats';

const About = () => {
  return (
    <div>
      <SEO 
        title="About Us | Grace Super Market Chennai"
        description="Learn about Grace Super Market's journey, our commitment to quality, and our expansion across Chennai with 39 stores serving fresh groceries and quality products."
        keywords="about Grace Super Market, Chennai retail chain, supermarket history, grocery stores Chennai"
        ogImage={aboutHero}
        canonicalUrl={`${process.env.REACT_APP_CURRENT_URL}/about`}
      />
      <HeroSection image={aboutHero} />
      <AboutContent />
      <BasketSection />
      <Stats />
    </div>
  );
};

export default About;